import { render, staticRenderFns } from "./TableHeading.vue?vue&type=template&id=01aeb25a&"
import script from "./TableHeading.vue?vue&type=script&lang=js&"
export * from "./TableHeading.vue?vue&type=script&lang=js&"
import style0 from "./TableHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports